var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg3(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_843_44836)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 2.5769C9.95601 2.5769 4.27375 4.93062 0 9.20438L1.62711 10.8315C5.46626 6.99233 10.5706 4.878 16 4.878C21.4294 4.878 26.5337 6.99233 30.3729 10.8315L32 9.20438C27.7263 4.93062 22.0441 2.5769 16 2.5769Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.33895 13.5433L5.96606 15.1704C8.64623 12.4903 12.2096 11.0143 16 11.0143C19.7904 11.0143 23.3538 12.4903 26.0339 15.1704L27.6611 13.5433C24.5463 10.4286 20.405 8.71317 16 8.71317C11.595 8.71317 7.45372 10.4286 4.33895 13.5433Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.67798 17.8824L10.3051 19.5095C13.4452 16.3694 18.5548 16.3694 21.695 19.5095L23.3221 17.8824C19.2847 13.8449 12.7153 13.8449 8.67798 17.8824Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 20.9857C13.6738 20.9857 11.7813 22.8782 11.7813 25.2044C11.7813 27.5306 13.6738 29.4231 16 29.4231C18.3262 29.4231 20.2187 27.5306 20.2187 25.2044C20.2187 22.8782 18.3262 20.9857 16 20.9857ZM16 27.122C14.9426 27.122 14.0824 26.2617 14.0824 25.2044C14.0824 24.147 14.9426 23.2868 16 23.2868C17.0574 23.2868 17.9176 24.147 17.9176 25.2044C17.9176 26.2617 17.0574 27.122 16 27.122Z",
    fill: "#222222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_843_44836"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.9c6648c143ebe08ea7a9f2d40cfc00ed.svg";
export { ForwardRef as ReactComponent };